import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

export const Background = styled.div`
  background-color: ${colors.white};
`;

export const Wrapper = styled.div<{ noBorder?: boolean }>`
  ${({ noBorder }) => !noBorder && css`border-bottom: 1px solid ${colors.darkGrey10};`}
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  height: 26px;
  font-size: 0.75rem;

  @media ${device.isMobile} {
    padding: 12px 0 12px 20px;
  }

  @media ${device.isTablet} {
    padding: 12px 32px;
  }

  @media ${device.isDesktop} {
    width: 960px;
    margin: 0 auto;
    padding: 12px 0;
  }
`;

export const Container = styled.div`
  transform: translate(-7px, 1px);

  @media ${device.isMobile} {
    display: none;
  }
`;

export const HomeButtonWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  overflow: hidden;
  outline-color: $christine;
  cursor: pointer;
  padding: 6px;
`;

export const HomeButtonIconHolder = styled.div<{
  mode: 'main' | 'secondary';
}>`
  width: 16px;
  height: 16px;
  transition: opacity 0.25s ease-in-out, transform 0.3s ease-in-out;
  ${props =>
    props.mode === 'secondary' &&
    `position: absolute;
    transformOrigin: center 49%;
  `}

  &[mode="main"] {
    opacity: 1;

    ${HomeButtonWrapper}:hover &, ${HomeButtonWrapper}:focus & {
      transform: rotate(180deg);
      opacity: 0;
    }
  }

  &:not([mode="main"]) {
    opacity: 0;

    ${HomeButtonWrapper}:hover &, ${HomeButtonWrapper}:focus & {
      transform: rotate(180deg);
      opacity: 1;
    }
  }
`;
